import styled from "@emotion/styled";
import { Flex } from "@unifize/sarah";
import * as colors from "src/styles/constants/colors";
import * as spacing from "src/styles/constants/spacing";
import { Status as Badge } from "src/styles/badge";
import { ButtonLink } from "src/styles/buttons";

export const NewBadge = styled(Badge)`
  display: inline-block;
  font-weight: normal;
  margin-right: ${spacing.space_m};
  margin-left: ${spacing.space_m};
  cursor: pointer;
  text-transform: uppercase;
  line-height: 1.6 !important;
  padding: 0 ${spacing.space_default} 0 ${spacing.space_default};
`;

export const ActionButton = styled(ButtonLink)`
  display: inline-flex;
  align-items: center;
  padding-left: 2.1rem;
  position: relative;
  line-height: normal;

  > span {
    padding-left: ${spacing.space_s};
  }

  svg {
    height: 1em;
    width: 1.3em;
    position: relative;
  }

  g {
    fill: ${colors.active};
  }
`;

export const ActionsContainer = styled(Flex)`
  white-space: nowrap;
  display: none !important;
  margin-left: 15px;
  align-items: center;
  justify-content: center;

  .ag-row-hover & {
    display: inline-flex !important;
  }
`;
